import React from 'react'

export default () => (
  <div>
  </div>
)


// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Sales.js